module.exports = __webpack_public_path__ + "static/media/IMG-4.2483bbe1.jpg";